import poliFoundationRequest from 'src/utils/poliFoundationRequest';

type FinishChatData = {
  origin: string;
  type: string;
  botflow?: any;
};

export class FinishChatService {
  static async finishChat(chat_uuid: string = '', data?: FinishChatData) {
    const url = `/contacts/${chat_uuid}/close`;
    const response = await poliFoundationRequest.post(url, data ?? null);
    return response.data;
  }
}
